import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'
import { Box, Typography, Alert } from '@mui/material'
import EditServiceRecurrenceFrequencySelector from 'components/configured-service/EditServiceRecurrenceDialog/components/EditServiceRecurrenceFrequencySelector'
import EditServiceRecurrenceDaysOfWeekSelector from 'components/configured-service/EditServiceRecurrenceDialog/components/EditServiceRecurrenceDaysOfWeekSelector'
import { isDailyRecurrence, isWeeklyRecurrence, isYearlyRecurrence as isYearlyRecurrenceUtil } from 'utils/service'
import {
  getUniqueRecurrenceOptions,
  findRecurrenceOptionByKey,
} from 'components/configured-service/EditServiceRecurrenceDialog/utils/recurrenceOptionsHelper'
import T from 'T'
import CreateServiceRecurrenceNonWeeklySelector from './CreateServiceRecurrenceNonWeeklySelector'

const CreateServiceRecurrenceForm = ({ metaFiltersData = {}, showYearly = false, isCompact = false }) => {
  const { watch } = useFormContext()

  const watchedServiceIntervalKey = watch('serviceInterval')

  const recurrenceOptions = useMemo(() => getUniqueRecurrenceOptions(metaFiltersData), [metaFiltersData])

  const watchedServiceInterval = useMemo(() => {
    return findRecurrenceOptionByKey(recurrenceOptions, watchedServiceIntervalKey)
  }, [recurrenceOptions, watchedServiceIntervalKey])

  // Check if the selected interval is daily
  const isDailyInterval = useMemo(() => {
    if (!watchedServiceInterval) return false

    return isDailyRecurrence(watchedServiceInterval.recurrenceInterval)
  }, [watchedServiceInterval])

  const isWeeklyRecurrenceType = useMemo(() => {
    if (!watchedServiceInterval) return true // Default to weekly behavior
    return isWeeklyRecurrence(watchedServiceInterval.recurrenceInterval)
  }, [watchedServiceInterval])

  const isYearlyRecurrence = useMemo(() => {
    return isYearlyRecurrenceUtil(watchedServiceInterval?.recurrenceInterval)
  }, [watchedServiceInterval])

  return (
    <Box>
      <Typography variant="h6" mb={2}>
        {T.RECURRENCE}
      </Typography>

      <EditServiceRecurrenceFrequencySelector metaFiltersData={metaFiltersData} showYearly={showYearly} />

      {isWeeklyRecurrenceType && <EditServiceRecurrenceDaysOfWeekSelector isCompact={isCompact} />}
      {!isWeeklyRecurrenceType && !isDailyInterval && !isYearlyRecurrence && <CreateServiceRecurrenceNonWeeklySelector />}
      {isYearlyRecurrence && (
        <Alert severity="warning" sx={{ mt: 2 }}>
          {T.YEARLY_SERVICE_WORK_ORDER_WARNING}
        </Alert>
      )}
    </Box>
  )
}

CreateServiceRecurrenceForm.propTypes = {
  metaFiltersData: PropTypes.object,
  showYearly: PropTypes.bool,
  isCompact: PropTypes.bool,
}

export default CreateServiceRecurrenceForm
